import { useCallback } from 'react'

import { useActiveOrgId } from '~/hooks/org'
import { useServerRequests } from '~/hooks/useRequests'

export const useSetTreasuryPasskey = () => {
  const { serverPostRequest, isProcessing: isSettingTreasuryPasskey } =
    useServerRequests()
  const orgId = useActiveOrgId()

  const setTreasuryPasskey = useCallback(
    (passkeyId: string, onError?: () => void) =>
      serverPostRequest({
        path: '/api/org/smart_accounts_setup/set_treasury_passkey',
        params: { orgId, passkeyId },
        errorMessage: 'Failed to save Treasury passkey',
        onError,
      }),
    [orgId, serverPostRequest],
  )

  return { setTreasuryPasskey, isSettingTreasuryPasskey }
}
